module.exports = __webpack_public_path__ + "img/to.d2d3783c.svg";